import { Checksum } from '@iotize/tap/client/impl';

/**
 * Created by IoTize on 19/04/2018.
 *
 * Split data into chunks with a size of maxPacketSize + 1
 * @param {Array} data
 * @param {number} maxPacketSize
 * @class
 */
export class BLEPacketSplitter {
  /*private*/ lastPacketSize: number;

  public data: Uint8Array;

  public maxPacketSize: number;

  public currentPacketIndex: number;

  /**
   *
   * @param data
   * @param maxPacketSize
   */
  public constructor(data: Uint8Array, maxPacketSize: number) {
    this.lastPacketSize = 0;
    this.maxPacketSize = 0;
    this.currentPacketIndex = 0;
    if (maxPacketSize < 1) {
      throw new Error('Packet size must be greater than 0');
    }
    this.data = data;
    this.maxPacketSize = maxPacketSize;
    this.currentPacketIndex = this.getTotalNumberOfPacket() - 1;
    this.lastPacketSize = this.getLastPacketSize();
  }

  /**
   * Create a BLEPacketSplitter instance from data and add the checksum at the end
   * @param {Array} data body data
   * @param {number} maxPacketSize packet size
   * @return {BLEPacketSplitter} the new instance
   */
  public static wrapWithChecksum(
    data: Uint8Array,
    maxPacketSize: number,
  ): BLEPacketSplitter {
    var checkSum = BLEPacketSplitter.computeChecksum(data);
    var wrappedData = new Uint8Array(data.length + 1);
    wrappedData.set(data);
    wrappedData.set([checkSum & 0xff], data.length);
    return new BLEPacketSplitter(wrappedData, maxPacketSize);
  }

  public getTotalNumberOfPacket(): number {
    return (
      ((this.data.length / this.maxPacketSize) | 0) +
      (this.data.length % this.maxPacketSize === 0 ? 0 : 1)
    );
  }

  public getLastPacketSize(): number {
    let result: number = this.data.length % this.maxPacketSize;
    if (result === 0) {
      result = this.maxPacketSize;
    }
    return result;
  }

  public getPackets(): Uint8Array[] {
    let packets: Uint8Array[] = [];
    while (this.hasNextPacket()) {
      packets.push(this.getNextPacket());
    }
    return packets;
  }

  public getNextPacket(): Uint8Array {
    let packetSize: number;
    let offset: number;
    if (this.currentPacketIndex > 0) {
      offset =
        this.lastPacketSize +
        (this.currentPacketIndex - 1) * this.maxPacketSize;
      packetSize = this.maxPacketSize;
    } else {
      offset = 0;
      packetSize = this.lastPacketSize;
    }
    let packet = new Uint8Array(packetSize + 1);
    packet[0] = (<number>offset) | 0;
    for (let i: number = 0; i < packetSize; i++) {
      packet[i + 1] = this.data[offset + i];
    }
    this.currentPacketIndex--;
    return packet;
  }

  public hasNextPacket(): boolean {
    return this.currentPacketIndex >= 0;
  }

  static computeChecksum(data: Uint8Array): number {
    return Checksum.compute(data) & 0xff;
  }

  public getTotalSize(): number {
    return this.data.length;
  }

  // public getCurrentPacketNumber(): number {
  //     return this.getTotalNumberOfPacket() - this.currentPacketIndex;
  // }

  // public toString(): string {
  //     return JSON.stringify(this);
  // }
}
